import { PolicyHolder, TodoCategory } from "@/shared/domain";

import { getSpApi, requestConfig } from "./apiRoot";
import { UrlManager } from "./UrlManager";

// Swagger: https://ibpcsrcdev01.portima.net/mybrokerapi/swagger/index.html

export const policyholderMapper = (source: PolicyHolder): PolicyHolder => {
    return {
        ...source,
        isWaiting: false,
        isPhysicalPerson: "isPhysicalPerson" in source ? source.isPhysicalPerson : true,
    };
};

/**
 * Returns policyholders
 */

export const getPolicyholders = async (): Promise<PolicyHolder[]> => {
    const { data } = await getSpApi().get<Paths.ApiPolicyholder.Get.Responses.$200>(UrlManager.policyholder());
    return data.map((policyholder) => policyholderMapper(policyholder));
};

export const getPolicyholdersPerAccessRightType = async (
    type: TodoCategory,
    policyholders: PolicyHolder[],
): Promise<PolicyHolder[]> => {
    switch (type) {
        case TodoCategory.LIABILITY:
            return policyholders.filter((policyholder) => policyholder.accessRights.canDeclareLiability10);
        case TodoCategory.COMMUNICATION_SALARY:
            return policyholders.filter((policyholder) => policyholder.accessRights.canCommunicateSalary);
        case TodoCategory.CUSTOMER_CARD:
            return policyholders.filter((policyholder) => policyholder.accessRights.canAccessCustomerForm);
        case TodoCategory.TARIFFICATION:
            return policyholders.filter((policyholder) => policyholder.accessRights.canAccessTariffication);
        default:
            return policyholders;
    }
};

export const getPolicyholderMandates = async (
    policyHolderId: number,
    ibpAclId: number,
): Promise<Paths.ApiPolicyholder$PolicyholderIdMandates.Get.Responses.$200> => {
    const params = {
        params: {
            accessRightsId: ibpAclId,
        },
    };

    const axiosRequestConfig = requestConfig<Paths.ApiPolicyholder$PolicyholderIdMandates.Get.QueryParameters>(params);

    const { data } = await getSpApi().get<Paths.ApiPolicyholder$PolicyholderIdMandates.Get.Responses.$200>(
        UrlManager.policyholderMandates(policyHolderId),
        axiosRequestConfig,
    );
    return data;
};

export const getCompanyDataVerification = async (
    policyholderId: string,
    params: Paths.ApiPolicyholder$PolicyholderIdMoralDetails.Get.QueryParameters,
): Promise<MyBrokerApi.MoralPersonDetails> => {
    const axiosRequestConfig = requestConfig<Paths.ApiPolicyholder$PolicyholderIdMoralDetails.Get.QueryParameters>({
        params,
    });
    const { data } = await getSpApi().get<Paths.ApiPolicyholder$PolicyholderIdMoralDetails.Get.Responses.$200>(
        UrlManager.companyDataVerification(policyholderId),
        axiosRequestConfig,
    );
    return data;
};
